<div class="dialog-container">
  <!-- Dialog Title -->
  <p mat-dialog-title style="font-weight: 500">
    <span *ngIf="data.type === 'sunmi' || data.type === 'windows'">
      {{ 'STORE_DIALOG.' + data.type.toUpperCase() + '.TITLE' | translate }}
    </span>
    <span *ngIf="data.type !== 'sunmi' && data.type !== 'windows'">
      {{ 'STORE_DIALOG.OUR_APPLICATIONS_ON' | translate }} {{ data.store_name }}
    </span>
  </p>

  <!-- Traditional Store Content -->
  <div class="row stores_dialog_body" *ngIf="data.type !== 'sunmi' && data.type !== 'windows'">
    <!-- Attendance App -->
    <a target="_blank" [href]="data.attendance" *ngIf="data.attendance">
      <div class="col-sm-12 store_row row mb-3">
        <div class="col-sm-3">
          <img src='./assets/images/store_apps/attendance.png'
            alt="{{ 'STORE_DIALOG.APPS.ATTENDANCE.NAME' | translate }}">
        </div>
        <div class="col-sm-9">
          <h3>{{ 'STORE_DIALOG.APPS.ATTENDANCE.NAME' | translate }}</h3>
          <p class="app-description">{{ 'STORE_DIALOG.APPS.ATTENDANCE.DESCRIPTION' | translate }}</p>
        </div>
      </div>
    </a>

    <!-- Provider App -->
    <!-- Temporarily hidden until links are corrected -->
    <!-- <a target="_blank" [href]="data.provider" *ngIf="data.provider">
      <div class="col-sm-12 store_row row mb-3">
        <div class="col-sm-3">
          <img src='./assets/images/store_apps/provider.png' alt="{{ 'STORE_DIALOG.APPS.PROVIDER.NAME' | translate }}">
        </div>
        <div class="col-sm-9">
          <h3>{{ 'STORE_DIALOG.APPS.PROVIDER.NAME' | translate }}</h3>
          <p class="app-description">{{ 'STORE_DIALOG.APPS.PROVIDER.DESCRIPTION' | translate }}</p>
        </div>
      </div>
    </a> -->

    <!-- E-commerce App -->
    <!-- Temporarily hidden until links are corrected -->
    <!-- <a target="_blank" [href]="data.ecommerce" *ngIf="data.ecommerce">
      <div class="col-sm-12 store_row row mb-3">
        <div class="col-sm-3">
          <img src='./assets/images/store_apps/ecommerce.png' alt="{{ 'STORE_DIALOG.APPS.ECOMMERCE.NAME' | translate }}">
        </div>
        <div class="col-sm-9">
          <h3>{{ 'STORE_DIALOG.APPS.ECOMMERCE.NAME' | translate }}</h3>
          <p class="app-description">{{ 'STORE_DIALOG.APPS.ECOMMERCE.DESCRIPTION' | translate }}</p>
        </div>
      </div>
    </a> -->

    <!-- No Apps Available Message -->
    <div class="col-sm-12" *ngIf="!data.attendance">
      <div class="no-apps-message text-center">
        <p>{{ 'STORE_DIALOG.NO_APPS_AVAILABLE' | translate }}</p>
      </div>
    </div>
  </div>

  <!-- Sunmi and Windows Content -->
  <div class="professional-store-content" *ngIf="data.type === 'sunmi' || data.type === 'windows'">
    <div class="description-section">
      <p class="store-description">
        {{ 'STORE_DIALOG.' + data.type.toUpperCase() + '.DESCRIPTION' | translate }}
      </p>
    </div>

    <div class="instruction-section">
      <h4 class="instruction-title">
        {{ 'STORE_DIALOG.HOW_TO_INSTALL' | translate }}
      </h4>
      <p class="instruction-text">
        {{ 'STORE_DIALOG.' + data.type.toUpperCase() + '.INSTRUCTION' | translate }}
      </p>
    </div>

    <div class="action-section" *ngIf="data.type === 'windows'">
      <div class="pwa-info">
        {{ 'STORE_DIALOG.WINDOWS.PWA_HINT' | translate }}
      </div>
    </div>
  </div>
</div>